<template>
  <div>
    <div class="header">
        <div class="header-top">
            <div class="header-top-con">
                <div class="header-top-left left">
                    <p style="float:left;margin:0 15px;">您好，欢迎来到深度配音</p>
                    <ul class="left" v-show="!userInfo.baseId">
                        <li class="unlogin showLoginModal on"><a href="javascript:;"></a></li>
                    </ul>
                    <ul class="left" v-show="userInfo.baseId">
                        <li class="logined"><a class="user-name" href="http://i.sd235.net" target="_blank" >Hi , {{userInfo.userPetname||'深度用户'}}</a></li>
                        <li class="logined"><a href="javascript:util.logout()">退出登录</a></li>
                    </ul>
                </div>
                <div class="header-top-right right">
                    <a class="hb" href="http://old.sd235.net" target="_blank">返回旧版</a>
                    <a class="hb" href="http://m.sd235.net" target="_blank">手机版</a>
                    <a class="hb" href="/APP" target="_blank">深度APP</a>
                    <a class="hb" href="/contact_us/contact_us" target="_blank">联系我们</a>
                    <a class="hb" href="/contact_us/safety-payment" target="_blank">付款账号</a>
                    <div class="myserve scrollx">
                        <a href="http://www.sd235.net/contact_us/company_produce">服务中心 <img class="arrow" src="../assets/img/arrow2.png" /> </a>
                        <div class="fuwuzhongxin scrolly">
                            <a href="http://www.sd235.net/contact_us/company_produce"> </a>
                            <a href="http://www.sd235.net/contact_us/company_produce" target="_blank" style="padding:0;border:none;"> <p>关于我们</p> </a>
                            <a href="http://www.sd235.net/contact_us/contact_us" target="_blank" style="padding:0;border:none;"> <p>联系我们</p> </a>
                            <a href="http://www.sd235.net/contact_us/teacher-in" target="_blank" style="padding:0;border:none;"> <p>加入我们</p> </a>
                            <a href="http://www.sd235.net/contact_us/safety-payment" target="_blank" style="padding:0;border:none;"> <p>汇款账号</p> </a>
                            <a href="http://www.sd235.net/contact_us/common-problems" target="_blank" style="padding:0;border:none;"> <p>常见问题</p> </a>
                            <a href="http://wpa.qq.com/msgrd?V=3&amp;uin=2851207395&amp;Site=深度配音投诉QQ&amp;Menu=yes" target="_blank" style="padding:0;border:none;"> <p>投诉</p> </a>
                            <!--<a href="http://www.oooyin.com" target="_blank" style="padding:0;border:none;"> <p>背景音乐</p> </a>-->
                            <a href="http://www.sd235.com" target="_blank" style="padding:0;border:none;"> <p>免费素材</p> </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="header-bottom">
            <div class="inner">
                <a href="/">
                    <img src="../assets/img/logo_cop.png" alt="">
                </a>
                <router-link class="title" to="{name:'OrderView'}">个人中心</router-link>
                <a class="search" :href="'/search/result?oldSearchStr='+oldSearchStr" target="_blank">搜索</a>
                <input type="text" placeholder="输入关键字搜索" @keyup.enter="toSearchPage" v-model="oldSearchStr">
            </div>
        </div>
    </div>


  </div>
</template>

<script type="es6">
	import { mapState, mapActions , mapGetters} from 'vuex'
  import { util } from '../service/util'

  let API = util.api([
      'LOGIN'
    ])
	export default {
      name: 'pay-success-view',
      components: {  },
      data () {
        return {
          res : '',
            oldSearchStr:''
        }
      },
      computed: {
        ...mapState({
            userInfo : state => state.common.userInfo,
            log : state => state.common.log
          }),
      },
      methods: {
        toSearchPage() {
            window.open('http://www.sd235.net/search/result#oldSearchStr='+this.oldSearchStr);
        }
      },
      created() {
        alert('支付成功，即将返回订单列表！');
        this.$router.push({
          name: 'OrderView'
        })
      },
      mounted(){

      }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// PaySuccessView.vue?2a04bc00